"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var AppRouter = function AppRouter(props) {
  var match = props.match,
      routes = props.routes;
  return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, null, routes.map(function (_ref, i) {
    var _ref$component = _ref.component,
        Comp = _ref$component === void 0 ? _reactRouterDom.Route : _ref$component,
        props = _ref.props;

    var component = props.component,
        renderElement = props.renderElement,
        path = props.path,
        restProps = _objectWithoutProperties(props, ["component", "renderElement", "path"]);

    return /*#__PURE__*/_react.default.createElement(Comp, {
      key: i,
      path: path ? "".concat(match.url + path) : null,
      // component: asyncLoader(props.component)
      component: typeof component === "function" ? /*#__PURE__*/_react.default.lazy(component) : component,
      render: function render() {
        return /*#__PURE__*/_react.default.createElement(renderElement, _objectSpread({
          urlData: match
        }, restProps));
      }
    });
  }));
};

var _default = AppRouter;
exports.default = _default;